module.exports = __webpack_public_path__ + "img/H4.0bf8c3f4.png";